import "./safe-area.css";
import { SafeArea } from './safe-area';
export default SafeArea;